import {showBanner} from "../../scripts/random/banner.js";
import CloudflareDNS from "./cloudflareSRV.js";
import Settings from "../../components/settings/Settings";

export default class FriServer {
    static PING_ENDPOINT = "/healthcheck";
    static DNS_PREFIX_TXT = "backend.";
    servers = [];
    DOMAIN="";
    localServers=["http://127.0.0.1:2082"];
    availableServers = [];

    constructor(domain,ret,showLoading) {
        this.DOMAIN=domain;
        this.initBackend(domain);
        if(this.checkIfElecronOrLocal()) {
            this.servers.push(this.localServers[0]);
        }
        this.ret=ret;
        this.failed=0;
        this.showLoading=showLoading;
    }

    async initBackend(domain)
    {
        var cd = new CloudflareDNS(FriServer.DNS_PREFIX_TXT+domain);
        var a = await cd.resolve("txt");
        var srvs="";
        if(a.Status===0)
            srvs = a.Answer[0].data.replace("\"","").replace("\"","").split(";");
        for(let i=0; i<srvs.length; i++)
        {
            this.servers.push("https://"+srvs[i]+"."+domain);
        }
        this.init();
    }

    init() {
        for (let i = 0; i < this.servers.length; i++) {
            this.getAvailable(this.servers[i]).then(res => {
                if(res.isAvailable && this.availableServers.length===0)
                {
                    showBanner(res.server);
                    Settings.save("server",res.server);
                    this.availableServers.push(res.server);
                    this.ret(res.server);
                }
                else
                {
                    this.failed++;
                }
            }).catch(e => {
                this.failed++;
                if(this.failed===this.servers.length)
                {
                    this.showLoading(true,"Z strežnikom se ni mogoče povezati. Poskusite znova kasneje.");
                }
            });
        }
    }

    async getAvailable(srv) {
        const json = await fetch(srv + FriServer.PING_ENDPOINT, {mode: "cors"})
            .then(response => response.text());
        return {server: srv, isAvailable: json === "pong"};
    }

    checkIfElecronOrLocal()
    {
        return window.location.href.indexOf(this.DOMAIN)===-1;
    }
}


// WEBPACK FOOTER //
// ./src/scripts/server/server.js